/**------------- Home Content constants -------------**/

/*  Logo  */
export const HOME_LOGO_CLASS_NAME = "logo-image";
export const HOME_LOGO_ALT = "company-logo-image";

/*  Title  */
export const HOME_TITLE = "MM Eletricar Service.";
export const HOME_TITLE_CLASS_NAME = "home-title";

/*  Subtitle  */
export const HOME_SUBTITLE =
	"Passione. Competenza. Esperienza.";
export const HOME_SUBTITLE_CLASS_NAME = "home-subtitle";

/*  Links  */
export const COMPANY_LOGO_LINK = "/images/logo.avif";
